import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import bg1 from "../assets/img/bg1.jpg";
import { useAuth } from "../Context/AuthContext";

export default function NewPassword() {
   const [pin, setPin] = useState("");
   const [newPassword, setPassword] = useState("");
   const [newPassword2, setPassword2] = useState("");
   const [showPassword, setShowPassword] = useState(false);
   const [showPassword2, setShowPassword2] = useState(false);
   const { completeResetPasswordChallenge, errorMessage, setErrorMessage } = useAuth();

   const location = useLocation();
   const { email } = location.state || {}; // Access challengeData and email from the state

   const handleNewPasswordSubmit = async (e) => {
      e.preventDefault();

      if (newPassword !== newPassword2) {
         setErrorMessage("Passwords do not match.");
         return;
      }
      completeResetPasswordChallenge(pin, email, newPassword);
   };
   return (
      <div className="page-sign d-block py-0">
         <Row className="g-0">
            <Col md="7" lg="5" xl="4" className="col-wrapper">
               <Card className="card-sign">
                  <Card.Header>
                     <Link to="/" className="header-logo mb-5">
                        Rekonsil
                     </Link>
                     <Card.Title>Reset Password</Card.Title>
                     <Card.Text>Enter your pin and provide a new password.</Card.Text>
                  </Card.Header>
                  <Card.Body>
                     <Form onSubmit={handleNewPasswordSubmit}>
                        <div className="mb-4">
                           <Form.Label>PIN</Form.Label>
                           <InputGroup>
                              <Form.Control type="text" placeholder="Enter pin" value={pin} onChange={(event) => setPin(event.target.value)} />
                           </InputGroup>
                        </div>
                        <div className="mb-4">
                           <Form.Label>Password</Form.Label>
                           <InputGroup>
                              <Form.Control type={showPassword ? "text" : "password"} placeholder="Enter your password" value={newPassword} onChange={(event) => setPassword(event.target.value)} />
                              <InputGroup.Text>
                                 <i onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</i>
                              </InputGroup.Text>
                           </InputGroup>
                        </div>
                        <div className="mb-4">
                           <InputGroup>
                              <Form.Control type={showPassword2 ? "text" : "password"} placeholder="Enter your password" value={newPassword2} onChange={(event) => setPassword2(event.target.value)} />
                              <InputGroup.Text>
                                 <i onClick={() => setShowPassword2(!showPassword2)}>{showPassword2 ? <FaEyeSlash /> : <FaEye />}</i>
                              </InputGroup.Text>
                           </InputGroup>
                        </div>
                        <Button type="submit" className="btn-sign">
                           Reset Password
                        </Button>
                        {errorMessage && (
                           <p className="pt-3" style={{ color: "red" }}>
                              {errorMessage}
                           </p>
                        )}
                     </Form>
                  </Card.Body>
                  <Card.Footer></Card.Footer>
               </Card>
            </Col>
            <Col className="d-none d-lg-block">
               <img src={bg1} className="auth-img" alt="" />
            </Col>
         </Row>
      </div>
   );
}
